import PropTypes from "prop-types";
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { STORAGEKEY } from "../../components/Constant";

const Authmiddleware = ({
  children,
  isAuthProtected,
  path,
  settings = false,
  administration = false,
}) => {
  const location = useLocation();
  let error = false;

  // Permissions from localStorage
  const customer_revenue = localStorage.getItem(STORAGEKEY.CUSTOMER_REVENUE);
  const customer_refund = localStorage.getItem(STORAGEKEY.CUSTOMER_REFUND);
  const role = localStorage.getItem(STORAGEKEY.ROLE);
  const staff_salary = localStorage.getItem(STORAGEKEY.STAFF_SALARY);
  const management = localStorage.getItem(STORAGEKEY.MANAGEMENT);
  const party_payment = localStorage.getItem(STORAGEKEY.PARTY_PAYMENT);
  const general_bills = localStorage.getItem(STORAGEKEY.GENERAL_BILL);
  const raw_material_bills = localStorage.getItem(STORAGEKEY.RAW_MATERIAL_BILL);
  const cancel_booking = localStorage.getItem(STORAGEKEY.CANCEL_BOOKING);

  // Auth check
  if (isAuthProtected && !localStorage.getItem(STORAGEKEY.ACCESSTOKEN)) {
    error = true;
  }

  // Expenses permissions
  if (
    ((path === "/unit-incomes" && customer_revenue !== "true") ||
      (path === "/customer-refund" && customer_refund !== "true") ||
      (path === "/cancel-booking" && cancel_booking !== "true") ||
      (path === "/material-expenses" && raw_material_bills !== "true") ||
      (path === "/general-expenses" && general_bills !== "true") ||
      (path === "/party-expenses" && party_payment !== "true") ||
      (path === "/employee-salary" && staff_salary !== "true")) &&
    role !== "superAdmin"
  ) {
    localStorage.clear();
    error = true;
  }

  // Configuration permissions
  if (settings && role !== "superAdmin") {
    localStorage.clear();
    error = true;
  }

  // Management permissions
  if (management !== "true" && administration && role !== "superAdmin") {
    localStorage.clear();
    error = true;
  }

  // Redirect to login if error
  if (error) {
    return <Navigate to="/user-login" state={{ from: location }} replace />;
  }

  // Render children
  return <>{children}</>;
};

Authmiddleware.propTypes = {
  isAuthProtected: PropTypes.bool,
  children: PropTypes.node.isRequired,
  path: PropTypes.string,
  settings: PropTypes.bool,
  administration: PropTypes.bool,
};

export default Authmiddleware;
